<template>
  <div class="home"  ref="pnlContent">
    <Navbar />
    <vue-headful title="CHECK CODE" />
    <fish-segment>
      <fish-loader :active="isLoading"></fish-loader>
      <fish-card fluid color="blue">
        <div slot="header">LỊCH SỬ TƯƠNG TÁC HỆ THỐNG</div>
        <a-table
          rowKey="Index"
          size="small"
          :columns="columns"
          :data-source="TBLdata"
          :pagination="false"
          :scroll="{x:600,y:ContentHeight}"
        >
          <!-- <span slot="Index" slot-scope="text,record,index">{{index+1}}</span> -->
          <span slot="Access_Result" slot-scope="text">
            <a-tag :color="text.toLowerCase().includes('success')?'green':'red'">{{text}}</a-tag>
          </span>
          <span slot="Access_Date" slot-scope="text">{{text|moment("DD/MM/YYYY HH:mm:ss")}}</span>
        </a-table>
        <div v-if="TBLdata && TBLdata.length>0" style="text-align:right;padding-top:5px">
          <a-pagination size="small" :pageSize="100" @change="fillData" :total="TBLdataTotal" />
        </div>
      </fish-card>
    </fish-segment>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import { mapActions } from "vuex";
let moment = require("moment");
export default {
  name: "HISTORY",
  components: {
    Navbar,
  },
  data() {
    return {
      ContentHeight:400,
      isLoading: false,
      page: 1,
      editingData: "",
      editingCust: "",
      columns: [
        {
          title: "#",
          dataIndex: "Index",
          key: "Index",
          width:"40px",
          scopedSlots: { customRender: "Index" },
        },
        {
          title: "TÀI KHOẢN",
          dataIndex: "Username",
          key: "Username",
        },
        {
          title: "LOẠI TƯƠNG TÁC",
          dataIndex: "Access_Type",
          key: "Access_Type",
        },
        {
          title: "DỮ LIỆU TƯƠNG TÁC",
          dataIndex: "Access_Data",
          key: "Access_Data",
        },
        {
          title: "TRẠNG THÁI",
          dataIndex: "Access_Result",
          key: "Access_Result",
          scopedSlots: { customRender: "Access_Result" },
        },
        {
          title: "NGÀY TƯƠNG TÁC",
          dataIndex: "Access_Date",
          key: "Access_Date",
          scopedSlots: { customRender: "Access_Date" },
        },
      ],
      TBLdata: [],
      TBLdataTotal: 0,
    };
  },
  mounted() {
    console.log(this.$refs)
    this.ContentHeight =  window.innerHeight-280//this.$refs.pnlContent.clientHeight;
    console.log(this.ContentHeight)
    this.fillData(1);
  },
  methods: {
    // Only show error after a field is touched.
    ...mapActions(["API_SabecoHistory"]),
    async fillData(page) {
      try {
        this.isLoading = true;
        let resData = await this.API_SabecoHistory(page);
        if (resData && resData.data && resData.data.State == 1) {
          this.TBLdataTotal = resData.data.Message.Total;
          this.TBLdata = resData.data.Message.Data.sort(function (a, b) {
            return moment(b.Access_Date) - moment(a.Access_Date);
          });
          this.TBLdata=this.TBLdata.filter(st=>st['Index']=this.TBLdata.indexOf(st)+1);
        } else {
          this.$message.error(resData.data.Message, 3000);
        }
        this.isLoading = false;
      } catch (err) {
        console.log("Err Fill Data:" + err.message);
        this.$message.error("Có lỗi xảy ra trong quá trình lấy dữ liệu!", 3000);
        this.isLoading = false;
      }
    },
  },
};
</script>